
































































/* Created- 20 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ParticaEvent, getActionName, eParticaAction } from "../../Models/ParticaEvent";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { IContentStreamPaymentService } from "../../BusinessServices/contentstreampayment";
import StreamTailorPayments from "@/Ui-Components/Account/StreamTailorPayments.vue";
import { IssueTailorPaymentDTO, ContentStreamIssueTailoringBatchDTO, ContentStreamIssueTailoringBatchItemDTO, ContentStreamIssueTailoringBatchDTOStatus } from "../../Generated/ParticaAPI";
import StreamTailoringBatches from "@/Ui-Components/Account/StreamTailorBatches.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import StreamTailorBatchItems from "@/Ui-Components/Account/StreamTailorBatchItems.vue";


@Component(
	{
		name: "AdminStreamTailorPayments",
		components: {
			ParticaView,
			ParticaCardXl,
			ParticaCard,
			StreamTailorPayments,
			StreamTailoringBatches,
			ButtonList,
			ParticaRightDrawer,
			StreamTailorBatchItems
		}
	})
export default class AdminStreamTailorPayments extends ParticaAdminBase {
	private service: IContentStreamPaymentService;
	private data: IssueTailorPaymentDTO[] = [];
	private paybuttons: ButtonConfig[] = [
		{ label: "Pay Owners", action: eParticaAction.CONTENT_STREAM_SEND_CURATOR_PAYMENTS, type: ButtonType.OK } as ButtonConfig
	];
	private createbatchbuttons: ButtonConfig[] = [
		{ label: "Create Batch", action: eParticaAction.CONTENT_STREAM_CREATE_BATCH, type: ButtonType.OK } as ButtonConfig
	];
	private outstandingMonths: string[] = [];
	private month: string = "";

	private batches: ContentStreamIssueTailoringBatchDTO[] = [];
	private batch: ContentStreamIssueTailoringBatchDTO = new ContentStreamIssueTailoringBatchDTO();
	private showbatch: boolean = false;
	private batchitems: ContentStreamIssueTailoringBatchItemDTO[] = [];

	private isBatchPaid(batch: ContentStreamIssueTailoringBatchDTO): boolean {
		if (batch.status === ContentStreamIssueTailoringBatchDTOStatus.FundsDeposited) {
			return true;
		}
		return false;
	}


	private getBatchTotal(): number {
		let total: number = 0;
		this.batchitems.forEach(x => { total += x.amount as number; });
		return total;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_CREATE_BATCH: {
					await this.service.CreateTailorBatch(this.month);
					this.ShowSnackbar(`Batch '${this.month}' created`);
					await this.init();
					break;
				}
				case eParticaAction.CONTENT_STREAM_SHOW_BATCH: {
					this.batch = event.item;
					this.batchitems = await this.service.GetTailorBatchItems(this.batch.id as number);
					this.showbatch = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_SEND_CURATOR_PAYMENTS: {
					await this.service.PayTailoringFees(this.batch.id as number);
					this.showbatch = false;
					await this.init(); // reload
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Outstanding Issue Tailoring Payments";
		this.service = this.particaServices.getContentStreampaymentService();
		this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAdminNav(0);
			this.data = await this.service.GetOutstandingTailor();
			this.outstandingMonths = await this.service.GetAvailableTailorMonths();
			this.batches = await this.service.GetTailorBatches();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
